import { render, staticRenderFns } from "./send-collect-customer.vue?vue&type=template&id=57c51ccf&scoped=true&"
import script from "./send-collect-customer.vue?vue&type=script&lang=ts&"
export * from "./send-collect-customer.vue?vue&type=script&lang=ts&"
import style0 from "./send-collect-customer.vue?vue&type=style&index=0&id=57c51ccf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c51ccf",
  null
  
)

export default component.exports